import { useState } from "react";
import { IAP_CATALOG } from "@/lib/iap-rewards";
import { Input } from "@/components/ui/input";

export function IapPicker({ value, onChange }: { value: string; onChange: (id: string) => void }) {
  const [search, setSearch] = useState("");
  const selected = IAP_CATALOG.find((p) => p.id === value);
  const matches = IAP_CATALOG.filter((p) => p.id === value || `${p.id} ${p.aliases.join(" ")} ${p.summary}`.toLowerCase().includes(search.toLowerCase()));
  return <div className="min-w-64 flex-1 space-y-1">
    <Input aria-label="Search IAP catalogue" placeholder="Search IAP catalogue…" value={search} onChange={(e) => setSearch(e.target.value)} />
    <select aria-label="IAP product" required value={value} onChange={(e) => onChange(e.target.value)} className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm">
      <option value="" disabled>Pick an IAP product</option>
      {value && !selected && <option value={value} disabled>{value} — unknown product</option>}
      {matches.map((p) => <option key={p.id} value={p.id} disabled={!!p.unavailable}>{p.id}{p.unavailable ? " — unavailable: " + p.unavailable : " — " + p.summary}</option>)}
    </select>
    {selected && <p className="text-xs text-muted-foreground">{selected.summary}</p>}
    <p className="text-xs text-muted-foreground">Quantity is the number of packs. Rewards are expanded when saved. Dynamic offers require their original reward payload.</p>
  </div>;
}
